"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAuthBasicHeader = void 0;
const generateAuthBasicHeader = (email, password) => {
    const token = btoa(`${email}:${password}`);
    return { Authorization: `Basic ${token}` };
};
exports.generateAuthBasicHeader = generateAuthBasicHeader;
exports.default = generateAuthBasicHeader;
